import { fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {
    switch (action.type) {

        case actions.GET_CONTACTS + actions.FULFILLED:
            {
                return state.set('contacts', fromJS(action.payload));
            }
        case actions.CLEAR_CONTACTS:
            {
                return state.set('contacts', fromJS([]));
            }
        case actions.SEARCH_COURSES:
        case actions.SEARCH_COURSES + actions.FULFILLED:
            {
                return state.set('courses', fromJS(action.payload));
            }
        case actions.CLEAR_SEARCHED_COURSES:
            {
                return state.set('courses', fromJS([]))
            }
        case actions.SEARCH_FACULTY + actions.FULFILLED:
            {
                return state.set('faculty', fromJS(action.payload));
            }
        case actions.SEARCH_PROGRAMS:
        case actions.SEARCH_PROGRAMS + actions.FULFILLED:
            {
                return state.set('programs', fromJS(action.payload));
            }
        case actions.SEARCH_PERSONS:
        case actions.SEARCH_PERSONS + actions.FULFILLED:
            {
                return state.set('persons', fromJS(action.payload));
            }
        case actions.CLEAR_SEARCHED_PERSONS:
            {
                return state.set('persons', fromJS([]))
            }
        case actions.TOGGLE_CONTACTS_FLIP_STATE + actions.FULFILLED:
            {
                return state.update('contacts', contacts => {
                    const index = contacts.findIndex(x => x.get('personId') === action.payload.personId);
                    return contacts.update(index, p => p.withMutations(mut => {
                        mut.set('isFlipped', !mut.get('isFlipped'));
                        mut.set('details', fromJS(action.payload));
                        return mut;
                    }));
                });
            }
        case actions.TOGGLE_CONTACTS_FLIP_STATE:
            {
                return state.update('contacts', contacts => {
                    const index = contacts.findIndex(x => x.get('personId') === action.payload);
                    return contacts.update(index, p => p.withMutations(mut => {
                        mut.set('isFlipped', !mut.get('isFlipped'));
                        mut.set('details', null);
                        return mut;
                    }));
                });
            }
        case actions.SET_CONTACT_ADVANCED_SEARCH_CRITERIA:
            {
                return state.withMutations(mut => {
                    mut.setIn(['criteria', action.field], action.payload);
                    mut.set('hasAdvancedSearchCriteria', true);
                });
            }
        case actions.CLEAR_TRAINING_CONTACTS_SEARCH:
            {
                return state.set('persons', fromJS([]));
            }
        case actions.CLEAR_CONTACT_SEARCH_CRITERIA:
            {
                return state.remove('personTypeId');
            }

        case actions.CLEAR_CONTACT_SEARCH_ADVANCED_CRITERIA:
            {
                return state.withMutations(mut => {
                    mut.set('criteria', fromJS({}));
                    mut.set('hasAdvancedSearchCriteria', false)
                });
            }

        case actions.SET_CONTACT_SEARCH_CRITERIA:
            {
                return state.set(action.field, action.payload);
            }

        case actions.GET_DAILYRATES_MIN_MAX + actions.FULFILLED:
            {
                return state.withMutations(mut => {
                    mut.set('dailyRatesMinMax', action.payload);
                    mut.setIn(['criteria', 'dailyRateRange'], action.payload);
                });
            }

        default:
            return state;
    }
}

const getInitialState = () => {
    return fromJS({
        courses: [],
        criteria: {
            isActive: true
        },
        persons: [],
        contacts: [],
        inactiveContacts: [],
        faculty: [],
        programs: [],
        dailyRatesMinMax: [0, 5000],
        hasAdvancedSearchCriteria: false
    });
}